import React, { useState, useRef, ChangeEvent } from 'react';
import { motion } from 'framer-motion';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import LoadingButton from '@mui/lab/LoadingButton';
import SendIcon from '@mui/icons-material/Send';

interface SendButtonProps {
  loading?: boolean;
  disabled?: boolean;
  onSend?: () => void;
}

const SendButton = ({ loading, disabled = false, onSend }: SendButtonProps) => {
  return (
    <motion.div whileTap={{ scale: 0.9 }} onClick={onSend}>
      <Box>
        <Tooltip title="Send" placement="top" enterDelay={1000}>
          <span>
            <LoadingButton
              loading={loading}
              size="small"
              disableRipple
              color="primary"
              variant="contained"
              disabled={disabled}
            >
              <SendIcon />
            </LoadingButton>
          </span>
        </Tooltip>
      </Box>
    </motion.div>
  );
};

export default SendButton;
